import {
  CREATE_TEST_SUCCESS,
  UPDATE_TEST_SUCCESS,
  DELETE_TEST_SUCCESS,
  GET_TEST_DETAILS_SUCCESS,
  GET_ALL_TEST_LIST_SUCCESS,
  SAVE_INSTRUCTIONSAUDIO_REQUEST,
  SAVE_INSTRUCTIONSAUDIO_SUCCESS,
  SAVE_INSTRUCTIONSAUDIO_FAILED,
  RESET_TEST_DETAILS,
  DELETE_TEST_QUESTION_SUCCESS,
  GET_TEST_TRACKER_SUCCESS,
  DELETE_TRACKER_SUCCESS,
  UPDATE_TEST_TRACKER_SUCCESS,
  DUPLICATE_TEST_SUCCESS,
  RESET_TEST_SUCCESS,
  UPDATE_TESTS_GRADEBOOK_SUCCESS,
  GET_TEST_DETAILS_BY_COURSEID,
  START_TEST_SUCCESS,
  FINISH_TEST_SUCCESS,
  FINISH_TEST_RESET,
  RESET_TESTS,
  RESET_TESTS_BY_COURSE,
  GET_SINGLE_TEST_TRACKER_SUCCESS,
  GET_SINGLE_TEST_TRACKER_FAILED,
  RESET_SINGLE_TEST_TRACKER,
} from "../constants";
import { cloneDeep, remove, findIndex } from "lodash";

export const initialState = {
  tests: [],
  testDetails: [],
  audio_file: "",
  testResults: [],
  testsByCourse: undefined,
  startedTestDetails: undefined,
  testFinish: undefined,
  singleTestTracker: undefined,
};
export const TestReducer = (state = initialState, action) => {
  //switch between action.type
  switch (action.type) {
    case GET_ALL_TEST_LIST_SUCCESS: {
      return {
        ...state,
        tests: action.payload,
      };
    }
    case START_TEST_SUCCESS: {
      return {
        ...state,
        startedTestDetails: action.payload,
      };
    }
    case FINISH_TEST_SUCCESS: {
      return {
        ...state,
        testFinish: action.payload,
      };
    }
    case FINISH_TEST_RESET: {
      return {
        ...state,
        testFinish: undefined,
      };
    }
    case CREATE_TEST_SUCCESS: {
      const tempTests = cloneDeep(state.tests);
      tempTests.data.splice(0, 0, action.payload);
      return {
        ...state,
        tests: tempTests,
        test_data: action.payload,
      };
    }
    case GET_TEST_DETAILS_SUCCESS: {
      return {
        ...state,
        testDetails: action.payload,
      };
    }

    case UPDATE_TEST_SUCCESS: {
      const tempTests = cloneDeep(state.tests.testDetails);
      const updatedTestDetails = tempTests.map((testDetail) => {
        return { ...testDetail, ...action.payload };
      });
      return {
        ...state,
        testDetails: updatedTestDetails,
      };
    }

    case UPDATE_TESTS_GRADEBOOK_SUCCESS: {
      const tempTests = cloneDeep(state.tests.testDetails);
      const updatedTestDetails = tempTests.map((testDetail) => {
        return { ...testDetail, ...action.payload };
      });
      return {
        ...state,
        testDetails: updatedTestDetails,
      };
    }
    case DELETE_TEST_SUCCESS: {
      const tempTests = cloneDeep(state.tests);
      remove(tempTests.data, (obj) => obj._id === action.payload);
      return {
        ...state,
        tests: tempTests,
      };
    }
    case SAVE_INSTRUCTIONSAUDIO_REQUEST: {
      return {
        ...state,
        audio_file: "",
      };
    }
    case SAVE_INSTRUCTIONSAUDIO_SUCCESS: {
      return {
        ...state,
        audio_file: action.payload.url,
      };
    }
    case SAVE_INSTRUCTIONSAUDIO_FAILED: {
      return {
        ...state,
        audio_file: "",
      };
    }
    case RESET_TEST_DETAILS: {
      return {
        ...state,
        testDetails: [],
      };
    }
    case DELETE_TEST_QUESTION_SUCCESS: {
      let tempoResDetail = cloneDeep(state.tests.testDetails);
      tempoResDetail = tempoResDetail.filter(
        (item) => !action.payload.ids.includes(item._id)
      );
      return {
        ...state,
        testDetails: tempoResDetail,
      };
    }
    case GET_TEST_TRACKER_SUCCESS: {
      return {
        ...state,
        testResults: action.payload,
      };
    }
    case DELETE_TRACKER_SUCCESS: {
      let tempoResDetail = cloneDeep(state.tests.testResults);
      tempoResDetail = tempoResDetail.filter(
        (item) => !action.payload.ids.includes(item._id)
      );
      return {
        ...state,
        testResults: tempoResDetail,
      };
    }
    case UPDATE_TEST_TRACKER_SUCCESS: {
      let tempoResDetail = cloneDeep(state.testResults);

      const index = findIndex(
        tempoResDetail,
        (obj) => obj._id === action.payload.trackerId,
        0
      );
      if (index !== -1) {
        tempoResDetail[index].responses = action.payload.responses;
      }
      return {
        ...state,
        testResults: tempoResDetail,
      };
    }
    case DUPLICATE_TEST_SUCCESS: {
      const tempTests = cloneDeep(state.tests);
      tempTests.data.splice(0, 0, action.payload);
      return {
        ...state,
        tests: tempTests,
      };
    }

    case RESET_TEST_SUCCESS: {
      let tempTests = cloneDeep(state.testResults);
      tempTests = tempTests.filter((item) => action.payload.tId !== item._id);
      return {
        ...state,
        testResults: tempTests,
      };
    }

    case GET_TEST_DETAILS_BY_COURSEID: {
      return {
        ...state,
        testsByCourse: action.payload,
      };
    }

    case RESET_TESTS: {
      return {
        ...state,
        tests: [],
      };
    }

    case RESET_TESTS_BY_COURSE: {
      return {
        ...state,
        testsByCourse: undefined,
      };
    }
    case GET_SINGLE_TEST_TRACKER_SUCCESS: {
      return {
        ...state,
        singleTestTracker: action.payload,
      };
    }
    case GET_SINGLE_TEST_TRACKER_FAILED: {
      return {
        ...state,
        singleTestTracker: action.payload,
      };
    }
    case RESET_SINGLE_TEST_TRACKER: {
      return {
        ...state,
        singleTestTracker: undefined,
      };
    }

    default:
      return state;
  }
};
